module.exports = __webpack_public_path__ + "img/BACK SEAT.7156c00d.svg";